import type { CSSProperties } from 'react';
import { useReducedMotion } from '@/hooks/useReducedMotion';
import type { FaceState } from '@/state/types';
import { useGaze } from './useGaze';
import { useGlitchSwap } from './useGlitchSwap';
import styles from './AsciiFace.module.css';

export interface AsciiFaceProps {
  state: FaceState;
}

export function AsciiFace({ state }: AsciiFaceProps) {
  const reduced = useReducedMotion();
  const { eyes, mouth, isGlitching } = useGlitchSwap(state, reduced);
  const gaze = useGaze(reduced);

  const style: CSSProperties = {
    ['--gx' as string]: gaze.x,
    ['--gy' as string]: gaze.y,
  };

  return (
    <pre
      ref={gaze.ref}
      className={styles.face}
      data-testid="ascii-face"
      data-state={state}
      {...(isGlitching ? { 'data-glitching': 'true' } : {})}
      aria-hidden="true"
      style={style}
    >
      {eyes}
      {'\n'}
      {mouth}
    </pre>
  );
}
